<template>
  <div class="dashboard">
    <TopNav />
    <DeployFilter :selection="selection" :projectID="projectID" />

    <div class="section">
      <div class="container has-text-centered">
        <p><span style="vertical-align: -20%">Compare:&nbsp;</span>
          <b-dropdown hoverable>
            <button class="button picker-button" slot="trigger">
              <span>{{ displayMode }}</span>
              <b-icon icon="menu-down"></b-icon>
            </button>

            <div v-for="(mode, idx) of modes" :key="idx">
              <b-dropdown-item :class="{'is-active': idx === selectedMode}" class="has-text-left" @click="selectMode(idx)">
                {{ modes[idx] }}
              </b-dropdown-item>
            </div>
          </b-dropdown>
        </p>
      </div>
    </div>

    <div class="section" v-if="selectedMode === TOP_N_MODE">
      <div class="columns column-dashboard">

        <div class="column" id="slide">
          <span v-if="topTraffic && topTraffic.old">
            <h2 class="title is-5 has-text-centered">
              Old Deploy: <code>{{ oldDeploySha1 }}</code> - {{ oldDeployDate }}
            </h2>
            <FunctionCards :hotpaths="topTraffic.old.hotpaths" />
          </span>
          <span v-else>
            <h2 class="has-text-centered"> No older deploys found </h2>
          </span>
        </div>

        <div class="column">
          <span v-if="topTraffic && topTraffic.old">
            <h2 class="title is-5 has-text-centered">
              Current Deploy: <code>{{ curDeploySha1 }}</code> - {{ curDeployDate }}
            </h2>
            <FunctionCards :hotpaths="topTraffic.new.hotpaths" />
          </span>
        </div>

      </div>

    </div>

    <div v-else-if="selectedMode === CMP_MODE">
      <TopNComparison
        :N="10"
        :onlyInOld="topTraffic.onlyInOld"
        :onlyInNew="topTraffic.onlyInNew"
        :inBoth="topTraffic.inBoth"
      />
    </div>
  </div>
</template>

<script>
import { gql } from "apollo-boost";

import FunctionCards from "@/components/FunctionCards.vue";
import TopNav from "@/components/TopNav.vue";
import TopNComparison from "@/components/TopNComparison.vue";
import DeployFilter from "@/components/DeployFilter.vue";

var moment = require("moment");

// this.$route.query.deployID
export default {
  name: "CompareDeploys",
  components: {
    TopNav,
    DeployFilter,
    FunctionCards,
    TopNComparison
  },
  apollo: {
    topTraffic: {
      query: gql`
        query topTraffic($query: TopTrafficQuery!) {
          topTraffic(query: $query) {
            new {
              deploy {
                time
                commit {
                  sha1
                }
              }
              hotpaths {
                percentage
                percentageChange
                newlyRanked
                rank
                rankChange
                samples
                name
                hash
              }
            }
            old {
              deploy {
                time
                commit {
                  sha1
                }
              }
              hotpaths {
                percentage
                percentageChange
                newlyRanked
                rank
                rankChange
                samples
                name
                hash
              }
            }
            onlyInOld {
              percentage
              rank
              name
            }
            onlyInNew {
              percentage
              rank
              name
            }
            inBoth {
              percentage
              percentageChange
              rank
              rankChange
              name
            }
          }
        }
      `,
      variables() {
        return {
          query: {
            projectID: this.projectID,
            PrevDeployID: this.deployID,
            topN: 10
          }
        };
      }
    }
  },
  props: {
    selection: {
      type: Number,
      default: -1
    },
    projectID: {
      type: Number,
      required: true
    },
    deployID: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      topTraffic: null,
      modes: ["Top 10 Lists", "Function By Function"],
      selectedMode: 0,
      TOP_N_MODE: 0,
      CMP_MODE: 1
    };
  },
  computed: {
    displayMode() {
      return this.modes[this.selectedMode];
    },
    oldDeploySha1() {
      return this.topTraffic.old.deploy.commit.sha1.substring(0, 8);
    },
    curDeploySha1() {
      return this.topTraffic.new.deploy.commit.sha1.substring(0, 8);
    },
    oldDeployDate() {
      return moment(this.topTraffic.old.deploy.time).format("MM/DD/YYYY HH:MM");
    },
    curDeployDate() {
      return moment(this.topTraffic.new.deploy.time).format("MM/DD/YYYY HH:MM");
    }
  },
  methods: {
    selectMode(idx) {
      this.selectedMode = idx;
    }
  }
};
</script>


<style>
.dashboard {
  background: #fafcff;
}
</style>
